<template>
  <div class="package-tier-editor">
    <div class="info-editor">
      <label class="label">ชื่อ</label>
      <el-input
        :value="value.name"
        class="input"
        @input="$emit('input', { ...value, name: $event })"
      ></el-input>
      <label class="label">รายการ Package</label>
      <ruejai-club-package-selector
        :value="value.packages"
        :disabled="disabled"
        class="input"
        @input="$emit('input', { ...value, packages: $event })"
      ></ruejai-club-package-selector>
    </div>
  </div>
</template>

<script>
import RuejaiClubPackageSelector from "@/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelector";

import { Input } from "element-ui";

export default {
  components: {
    RuejaiClubPackageSelector,
    "el-input": Input,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-tier-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}
</style>
